import React, { useEffect, useState } from 'react';
import { searchProperties } from '../../../services/propertyService';
import TabNavigation from '../../resultPage/tabNavigation';
import DataTableSection from '../../resultPage/datatable';
import { useLocation, useParams } from 'react-router-dom';

const AllPropertyPage = () => {
  const location = useLocation();
  const { city } = useParams(); // Extract city from the URL params
  const [selectedSort, setSelectedSort] = useState("Relevance"); // State for sorting
  const [activeTab, setActiveTab] = useState("Sell"); // Default to "Sell"
  // Parse location data from query params
  const searchParams = new URLSearchParams(location.search);
  const locationData = searchParams.get("location") ? JSON.parse(decodeURIComponent(searchParams.get("location"))) : null;
  const queryTab = searchParams.get("activeTab");
  // Set cityName: If locationData exists, use its city, otherwise fallback to URL city param
  const cityName = locationData?.city || city || "Jaipur";

  useEffect(() => {
    setActiveTab(queryTab || "Sell"); // Set activeTab from query or default to "Sell"
  }, [queryTab]);




  // State for API results
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  // Fetch properties function
  const fetchProperties = async () => {
    setLoading(true);
    setError(null);



    try {
      const formData = new FormData();
      // Helper function to append only non-empty values
      const appendIfExists = (key, value) => {
        if (value && (Array.isArray(value) ? value.length > 0 : true)) {
          formData.append(key, Array.isArray(value) ? JSON.stringify(value) : value);
        }
      };
      appendIfExists("location", cityName);
      appendIfExists("sortOption", selectedSort); // **Pass selected sort option**
      appendIfExists("activeTab", activeTab); // Pass active tab
      const response = await searchProperties(formData);

      if (response?.success) {
        setSearchResults(response.properties || []);
        setTotalResults(response.totalResults || 0);
        setTotalPages(response.totalPages || 1);
        setCurrentPage(response.currentPage || 1);
      } else {
        setSearchResults([]);
        setTotalResults(0);
        setTotalPages(1);
        setCurrentPage(1);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch properties on component mount or when cityName changes
  useEffect(() => {
    fetchProperties();
  }, [cityName,selectedSort,activeTab]);

  return (
    <div className='py-[150px] bg-[#f5f5f5]'>
      <div className='w-[78%] ml-5'>
        <TabNavigation totalResults={totalResults} setSelectedSort={setSelectedSort} />

        <div className='py-4'>
          <p className='text-[26px] font-normal capitalize'>
          {totalResults.toLocaleString()}+ properties available in <span className='text- font-bold'>{cityName}</span> for <span className='capitalize text-gray-900'>{activeTab}</span>
          </p>
        </div>

        {/* Loading & Error Handling */}
        {loading ? (
          <p>Loading properties...</p>
        ) : error ? (
          <p className="text-red-500">Error: {error.message}</p>
        ) : searchResults.length > 0 ? (
          <DataTableSection searchResults={searchResults} />
        ) : (
          <p className="text-gray-500">No properties found.</p>
        )}
      </div>

      <div className='w-[5%]'></div>
      <div className='w-[25%]'></div>
    </div>
  );
};

export default AllPropertyPage;
